import { ViewData } from '../../../model/view.data';
import { CountryVO } from '../../../vo/locale/country.vo';
import { Model } from '../../../model/model';
import { ExternalAPI } from '../../../model/external-api';
import { CountryWrapper, BasicCriteria, CountryScenario } from '@wizeoo/akm-message-lib';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';

/**
 * Commande dédiée aux pays
 * @author sva
 */
export class CountryCmd extends WizCommand<CountryWrapper> {
 
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  /** retourne un wrapper pre-alimenté */
  public countryWrapper(): CountryWrapper {
    const wrapper: CountryWrapper = new CountryWrapper();
    wrapper.criteria = new BasicCriteria();
    wrapper.criteria.domain = ViewData.wildcardDomain;
    wrapper.criteria.businessUnitCode = ViewData.wildcardDomain;
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    wrapper.scenario = new CountryScenario();
    wrapper.scenario.manageLanguages = true;
    return wrapper;
  }

  /**
   * Chargement de tous les pays du domaine
   * @return CountryCmd cette commande
   */
  public find(): CountryCmd {
    const wrapper: CountryWrapper = this.countryWrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.COUNTRY_API, wrapper);
    return this;
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();

    if(!!this.result?.entities) {
      // Construction des VO country
      const countries: CountryVO[] = this.result.entities.map((element) => new CountryVO(this.model, element));
      // construction de la map
      const countriesMap = new Map();
      countries.reduce((map: Map<string, CountryVO>, country: CountryVO) => {
        map.set(country.code, country);
        return map;
      }, countriesMap);
      // Initialisation du model
      this.model.countryMap = countriesMap;
      this.model.countryList = countries;
    } else {
      console.log('no country for old men', this);
    }


  }
}
